import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DialogHeader from 'screens/components/basic/DialogHeader'
import WithRouter from 'custom/withRouter';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

class SupportLandingApp extends Component {
  constructor(props, context) {
    super(props, context);
  }
  redirectToGettingStarted = () => {
    this.props.navigate("/support/getting-started");
  }

  redirectToFaq = () => {
    this.props.navigate("/support/faq");
  }

  redirectToVideo = () => {
    this.props.navigate("/support/videos");
  }

  directToGuideline(id) {
    this.props.navigate(`/support-document#${id}`);
  }

  render() {

    return (
      <React.Fragment>
        <DialogHeader text="Help Center"/>
        {/* Topics Section */}
        <h5 className="pa-1 bold">Topics</h5>
        {/* System Overview */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>System Overview</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
              <li>
                <a href="/support-document#major-features" underline="hover">
                  Major Features
                </a>
              </li>
              <li>
                <a href="/support-document#getting-started" underline="hover">
                  Getting Started
                </a>
              </li>
            </Box>
          </AccordionDetails>
        </Accordion>
        {/* Installation */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Installation</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
              <li>
                <a href="/support-document#printer-installation" underline="hover">
                  Printer Installation
                </a>
              </li>
              <li>
                <a href="/support-document#service-installation" underline="hover">
                  Service Installation
                </a>
              </li>
            </Box>
          </AccordionDetails>
        </Accordion>
        {/* Measurement Settings */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Measurement Settings</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
              <li>
                <a href="/support-document#create-measurement" underline="hover">
                  Create a Measurement Setting
                </a>
              </li>
              <li>
                <a href="/support-document#edit-measurement" underline="hover">
                  Edit a Measurement Setting
                </a>
              </li>
            </Box>
          </AccordionDetails>
        </Accordion>
        {/* Header */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Price Matrix</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
              <li><a href="/support-document#add-price-matrix" >Add a Price Matrix</a></li>
              <li><a href="/support-document#edit-price-matrix" >Edit a Price Matrix</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Product</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
                <li><a href="/support-document#add-product-category" >Add a Product Category</a></li>
                <li><a href="/support-document#add-products" >Add Products</a></li>
                <li><a href="/support-document#add-prepack-product" >Add Pre-Pack Products</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Smart Inventory</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
                <li><a href="/support-document#create-purchase-order" >Create a Purchase Order</a></li>
                <li><a href="/support-document#edit-purchase-order" >Edit a Purchase Order</a></li>
                <li><a href="/support-document#receive-product" >Receive a product</a></li>
                <li><a href="/support-document#create-joint" >Create Joints</a></li>
                <li><a href="/support-document#transfer-product" >Transfer Products between Warehouses</a></li>
                <li><a href="/support-document#adjust-item" >What is adjusting items?</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>User</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
                <li><a href="/support-document#add-employee" >Add an Employee</a></li>
                <li><a href="/support-document#edit-employee" >Edit an Employee</a></li>
                <li><a href="/support-document#add-patient" >Add a Member</a></li>
                <li><a href="/support-document#edit-patient" >Edit a Member</a></li>
                <li><a href="/support-document#role-access" >Role Access</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>POS Sales</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
                <li><a href="/support-document#pos-how-to" >How to Use POS Sales</a></li>
                <li><a href="/support-document#pos-add-patient" >How to Link a Member to an Order</a></li>
                <li><a href="/support-document#pos-lookup-product" >How to Look for a Product</a></li>
                <li><a href="/support-document#pos-nonCannabis-order" >How to Start a Non-Cannabis Order</a></li>
                <li><a href="/support-document#pos-unitCannabis-order" >How to Start an Order with a Unit-Cannabis Product</a></li>
                <li><a href="/support-document#pos-bulkCannabis-order" >How to Start an Order with a Bulk-Cannabis Product</a></li>
                <li><a href="/support-document#pos-resume-order" >How to Resume an Open Order for a Given Member</a></li>
                <li><a href="/support-document#pos-cancel-order" >How to Cancel an Order</a></li>
                <li><a href="/support-document#pos-apply-discount" >How to Apply a Discount</a></li>
                <li><a href="/support-document#pos-unable-sell-prePack" >I'm Unable to Sell a Pre-Pack Product</a></li>
                <li><a href="/support-document#pos-pay-cash" >How to Pay with Cash</a></li>
                <li><a href="/support-document#pos-pay-debit" >How to Pay with Debit</a></li>
                <li><a href="/support-document#pos-inStore-credit" >How to Pay with Store Credit</a></li>
                <li><a href="/support-document#pos-refund" >How to Refund an Item</a></li>
                <li><a href="/support-document#pos-cash-drop" >Cash Drop</a></li>
                <li><a href="/support-document#pos-close-register" >How to Close the Register from POS Screen</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Payment & Taxes</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
                <li><a href="/support-document#payment-tax-pay" >Payment</a></li>
                <li><a href="/support-document#payment-tax-tax" >Taxes</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Admin</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
                <li><a href="/support-document#admin-cash-register" >Cash Register</a></li>
                <li><a href="/support-document#admin-view-orders" >How to View an Order</a></li>
                <li><a href="/support-document#admin-cancel-order" >How to Cancel an Order</a></li>
                <li><a href="/support-document#admin-register-status" >Register Status</a></li>
                <li><a href="/support-document#admin-close-register" >How to Close a Register</a></li>
                <li><a href="/support-document#admin-cash-out" >How to Cash Out</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Reports</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
                <li><a href="/support-document#reports-report" >Reports</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Scheduling</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
              <li><a href="/support-document#scheduling-how-to" >How to Use the Schedule Feature</a></li>
              <li><a href="/support-document#scheduling-edit" >How to Edit a Scheduled Shift</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Clock In / Clock Out</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
                <li><a href="/support-document#clock-in-out-how-to" >How to Clock In / Clock Out</a></li>
                <li><a href="/support-document#clock-in-out-problem" >If There's a Problem with Your Shift</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Pin-Pad</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
                <li><a href="/support-document#pin-pad-how-to" >How to Use the PinPad Feature</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Check-In</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
                <li><a href="/support-document#check-in" >How to Use the Check-In Feature</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Twilio Setup</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
              <li><a href="/support-document#twilio-setup" >How to Set Up Twilio Account</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        {/* Plugins Section */}
        <h5 className="pa-1 bold">Plugins</h5>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Campaign</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
                <li><a href="/support-document#campaign-rules" >Campaign Rules</a></li>
                <li><a href="/support-document#campaign-create" >How to Create a Campaign</a></li>
                <li><a href="/support-document#campaign-edit" >How to Edit a Campaign</a></li>
                <li><a href="/support-document#campaign-cannot-add" >I Can’t Add a Campaign</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Web-Menu</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
              <li><a href="/support-document#web-menu-desc" >Web Menu Description</a></li>
              <li><a href="/support-document#web-menu-create-group" >How to Create Product Groups to display on the Web Menu</a></li>
              <li><a href="/support-document#web-menu-finalize" >How to Finalize the look of the Web Menu</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        {/* Troubleshooting Section */}
        <h5 className="pa-1 bold">Troubleshooting</h5>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Barcode Scanner</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
              <li><a href="/support-document#barcode" >Having Trouble Scanning Barcodes?</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Hardware</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
              <li><a href="/support-document#error-message" >Message: "There is a problem with your hardware, contact your system administrator"</a></li>
              <li><a href="/support-document#label-printer" >The label printer doesn't print properly</a></li>
              <li><a href="/support-document#ip-address" >IPv6 Address</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>General</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
              <li><a href="/support-document#new-version" >Unable to see a new version</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Product</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
              <li><a href="/support-document#trouble-prepack" >Unable to sell a Pre-Pack product</a></li>
              <li><a href="/support-document#trouble-priceMatrix-campaign" >The product with a Price Matrix doesn't participate in the Campaign</a></li>
              <li><a href="/support-document#trouble-add-campaign" >Unable to add to a Campaign</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>User</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ul" sx={{ pl: 2 }}>
              <li><a href="/support-document#trouble-login" >Login Issues</a></li>
              <li><a href="/support-document#trouble-forgot-pw" >Employee - Forgot password</a></li>
              <li><a href="/support-document#trouble-change-pw" >Employee - Change password</a></li>
            </Box>
          </AccordionDetails>
        </Accordion>
      </React.Fragment>
    );
  }
}

export default WithRouter(SupportLandingApp);